export default {
  en: {
    upload: 'Upload from device',
    recently_attached: 'You recently attached this image',
    clear_attached: 'Clear attached',
    remove: 'Remove',
  },
};
